import { AEClient, TwilioClient } from ".";

export let UnifiedChatClient: typeof AEClient | typeof TwilioClient;

export const useChatClient = () => UnifiedChatClient ?? TwilioClient;

export const getChatClient = (
  partner: string,
  _queue: string,
  _userId: string,
) => {
  if(['verizon','att','cricket','liberty','vip','sprint'].includes(partner)){
    return (UnifiedChatClient = TwilioClient);
  }else{
    return (UnifiedChatClient = AEClient);
  }
}
